module.exports = __webpack_public_path__ + "static/img/p-img4.08d5bc9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/forum/p-img4.png
// module id = ffzw
// module chunks = 202